import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { runtimeEnvironment } from '../../../environments/environment';

export interface IDialogData {
  titleIcon: string;
  title: string;
  messageIcon: string;
  message: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  confirmButtonDisabled?: boolean;
  confirmButtonTooltip?: string;
  hideCancelButton?: boolean;
  hideConfirmButton?: boolean;
}

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss', './chrome-extension.confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {
  renderMode = runtimeEnvironment.renderMode;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: IDialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.data.confirmButtonText = this.data.confirmButtonText ? this.data.confirmButtonText : 'Yes';
    this.data.cancelButtonText = this.data.cancelButtonText ? this.data.cancelButtonText : 'No';
    this.data.confirmButtonTooltip = this.data.confirmButtonTooltip ? this.data.confirmButtonTooltip : '';
  }
}
